<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import CreateUrun from "./create_urun.vue";
import datatableMixin from '@/helpers/mixins/datatableMixin'
import Datatable from '@/components/Datatable'

export default {
  page: {
    title: "Ürün Yönetimi",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  mixins: [datatableMixin],
  components: {
    Layout,
    PageHeader,
    CreateUrun,
    Datatable
  },
  data() {
    return {
            list: {},
            title: "ÜRÜN YÖNETİMİ",
            items: [
            {
                text: "ANASAYFA",
                href: "/",
            },
            {
                text: "ÜRÜN YÖNETİMİ",
                active: true,
            },
            ],
            columns: [
                { name: '', key: 'action', orderable: false, width: 10 },
                { name: 'Grup', key: 'group', orderable: false },
                { name: 'Ürün Hizmeti', key: 'name', orderable: true },
                { name: 'Satış Fiyatı', key: 'price', orderable: true },
                { name: 'Birim', key: 'unit', orderable: false },
            ],
            tableData: {
                detail: false,
                excel: false,
                searchable: {
                    visible: true,
                    placeholder: "Ürün adı ara"
                }
            },
            endpoint: '/stock/product',
            exportName: 'URUN_LISTESI',
        };
    },
    methods: {
        groupName(row) {
            const groups = {
                ka: 'Kablo',
                mo: 'Modem',
                sm: 'Sarf Malzeme',
                si: 'Sabit İp Ücreti',
            };
            const altGroups = {
                1: 'Mikrotik',
                2: 'Ubiquiti',
                3: 'Mimosa',
            };

            return row.alt_group_id > 0 ? altGroups[row.alt_group_id] : groups[row.group_id];
        },
        async loadPage() {
            this.params.page === 1 ? this.isLoading = true : this.pageLoading = true;

            try {
                const response = await this.$http.post(this.endpoint, {
                    params: this.params,
                    search_params: this.searchParams,
                    sort: this.sort,
                    search_query: this.searchQuery
                });

                if (this.params.page === 1) {
                    this.tableData.data = response.data.data;
                } else {
                    this.tableData.data = [...this.tableData.data, ...response.data.data];
                }

                this.tableData.pagination = {
                    current_page: response.data.current_page,
                    last_page: response.data.last_page,
                    total: response.data.total
                };
            } finally {
                this.params.page === 1 ? this.isLoading = false : this.pageLoading = false;
            }
        },
        loadItems() {
            this.reLoadPage(this.searchQuery);
        },
        create(){
            this.list = {}
            this.$parent.$bvModal.show('modal-urun')
        },
        update(props){
            this.list = { ...props, type: 'update' }
            this.$parent.$bvModal.show('modal-urun')
        },
    },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <CreateUrun
        :list="list"
        @loadItems="loadItems"
    />

    <div class="row">
        <div class="col-12">
            <Datatable
                :columns="columns"
                :tableData="tableData"
                @sort-column="handleSortColumn"
                @search-query="reLoadPage"
                :loading="isLoading"
                :poading="pageLoading"
            >
                <template #toolbar>
                    <button class="btn btn-success" type="button" @click="create()">
                        <i class="bx bx-plus"></i> Yeni Oluştur
                    </button>
                </template>

                <template #action="{ row }">
                    <b-dropdown
                        toggle-class="font-size-16 p-0"
                        toggle-tag="a"
                        variant="white"
                        append-to-body
                    >
                        <template #button-content>
                            <i class="mdi mdi-dots-horizontal"></i>
                        </template>
                        <b-dropdown-item @click="update(row)">Düzenle</b-dropdown-item>
                    </b-dropdown>
                </template>

                <template #group="{ row }">{{ groupName(row) }}</template>
                <template #price="{ row }">{{ $paraFormat(row.price) }}</template>
            </Datatable>
        </div>
    </div>
  </Layout>
</template>
